<template>
  <li class="history-item">
    <div class="history-time">{{time}}</div>
    <div class="item-list" v-if="history.type === 2">
      <template v-for="(item, index) in history.comItems">
        <div class="item ff-item" :key="index">
          <div class="item-inner ff-item-inner">
            <div class="img" :style="{'background-image': 'url('+ item.thumb + ')'}"></div>
            <div v-show="item.nums > 1" class="item-nums"><span>x</span><span>{{item.nums}}</span></div>
          </div>
        </div>
      </template>
    </div>
    <div class="item-desc" v-else>{{$bus.transify['T_KU_HIS_REFRESH']}}</div>
    <div class="history-cost">
      <p class="cost">
        <i class="diamond"></i>
        <span class="gem-nums" :class="history.price === 0 ? 'free': ''">{{history.price === 0 ? $bus.transify['T_FREE_TEXT'] : history.price}}</span>
      </p>
      <p class="discount" v-show="history.discount">
        <span>{{history.discount + '%'}}</span>
        <span>{{$bus.transify['T_P_OFF']}}</span>
      </p>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    time: String,
    history: Object
  }
}
</script>

<style lang="scss" scoped>
.history-item {
  @include px2res(height, 106);
  @include px2res(font-size, 24);
  @include flexrc;
  justify-content: space-between;
  @include px2res(padding, 0, 14, 0, 0);
  width: 100%;
  position: relative;
  white-space: normal;
  .item-list {
    @include px2res(width, 300);
    @include flexrc;
    justify-content: flex-start;
    .item {
      @include px2res(margin, 0, 10);
      @include px2res(width, 80);
      @include flexrc;
      flex-direction: column;
      overflow: hidden;
      .item-inner {
        position: relative;
        @include flexrc;
        @include px2res(width, 80);
        @include px2res(height, 80);
        .img {
          @include px2res(width, 61);
          @include px2res(height, 61);
          background-size: contain;
        }
        .item-nums {
          color: #FFDE00;
          font-weight: 500;
          position: absolute;
          z-index: 3;
          @include px2res(top, 6);
          @include px2res(right, 10);
          @include px2res(font-size, 20);
        }
      }
    }
  }
  .item-desc {
    @include px2res(width, 300);
    @include px2res(padding, 0, 10);
    @include px2res(font-size, 32);
    line-height: 1;
  }
  .history-cost {
    @include flexrc;
    flex-direction: column;
    align-items: flex-end;
    @include px2res(width, 126);
    font-weight: 500;
    white-space: nowrap;
    .cost {
      @include flexrc;
      position: relative;
      line-height: 1.2;
      align-items: flex-end;
      @include px2res(font-size, 32);
      .diamond {
        @include px2res(width, 30);
        @include px2res(height, 26);
        @include px2res(margin-right, 4);
      }
      .gem-nums {
        @include px2res(height, 30);
      }
    }
    .discount {
      @include flexrc;
      position: relative;
      line-height: 1.2;
      align-items: flex-end;
      @include px2res(font-size, 32);
      color: #FFDE00;
      text-transform: uppercase;
      font-weight: 500;
    }
  }
  .history-time {
    text-align: center;
    line-height: 1;
    @include px2res(width, 250);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/history/item.vue